export default "__VITE_ASSET__CiZqy4wa__"